import Vue from 'ninenine-white-label/Vue'
import Vuex from 'vuex'

import opportunities from 'ninenine-white-label/store/modules/opportunities'
import location from 'ninenine-white-label/store/modules/location'
import user from 'ninenine-white-label/store/modules/user'
import domains from 'ninenine-white-label/store/modules/domains'
import graphql_queries from 'ninenine-white-label/store/modules/graphql_queries'
import tests from 'ninenine-white-label/store/modules/tests'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    opportunities,
    location,
    user,
    domains,
    graphql_queries,
    tests
  },

  state: {
    source: 'carreiras',
    companyId: process.env.VUE_APP_COMPANY_ID,

    tkn: `Token token=${process.env.VUE_APP_API_TOKEN}`,

    deviseForm: null,
    deviseLoading: false,

    deviseTrying: { },

    deviseClosedToReadTerms: { },
    pendingAcceptTerms: false,

    personalDataForm: { },
    educationsForms: [],
    professionalExperiencesForms: [],
    languagesForms: [],
    flag_no_professional_experience: false,
    opportunityQuestionsForm: { },
    indicationForm: { },

    companyName: 'Rendimento',

    websiteName: 'Rendimento Carreiras',

    areas: [
      {
        "id": 3455,
        "name": "Compras",
      },
      {
        "id": 3464,
        "name": "Engenharia",
      },
      {
        "id": 3454,
        "name": "Finanças",
      },
      {
        "id": 3465,
        "name": "Fiscal e Tributária",
      },
      {
        "id": 3457,
        "name": "Logística",
      },
      {
        "id": 3493,
        "name": "Manutenção",
      },
      {
        "id": 3452,
        "name": "Marketing",
      },
      {
        "id": 3492,
        "name": "Operações",
      },
      {
        "id": 3466,
        "name": "Produção e Fabricação",
      },
      {
        "id": 3456,
        "name": "Qualidade",
      },
      {
        "id": 3453,
        "name": "Recursos Humanos",
      },
      {
        "id": 3459,
        "name": "Serviços Gerais",
      },
      {
        "id": 3467,
        "name": "Suprimentos (Compras)",
      },
      {
        "id": 3468,
        "name": "Tecnologia",
      },
    ],

    teams: [
      {
        "title": "Matriz (escritório)",
        "slug": "escritorio",
        "coverImage": "thumb-collection-escritorio.jpeg"
      },
      {
        "title": "Lojas Lopes",
        "slug": "lopes",
        "coverImage": "thumb-collection-lopes.jpg"
      },
      {
        "title": "Lojas Raiz",
        "slug": "raiz",
        "coverImage": "thumb-collection-raiz.jpg"
      },
      {
        "title": "Centro de Distribuição",
        "slug": "distribuicao",
        "coverImage": "thumb-collection-distribuicao.jpeg"
      },
    ],

    occupationArea:[
      {
        "title":"Recursos Humanos",
        "image":"rh.png",
        "image2":"rh2.png",
        "content":"Trabalhamos para compreender as necessidades dos colaboradores, nossos colegas, e propor uma jornada de desenvolvimento humanizada e produtiva, para que cada um possa atingir o máximo de seu potencial.",
      },
      {
        "title":"Comercial, Comercial Câmbio e Crédito",
        "image":"comercial.png",
        "image2":"comercial2.png",
        "content":"Nossa missão é gerar valor e uma experiência única aos nossos clientes. Atendemos pessoa física, jurídica e parceiros com produtos em câmbio, crédito, cartões, investimentos e serviços, levando soluções sob medida para cada tipo de necessidade.",
      },
      {
        "title":"Lojas, Mesas de Operações, Logística e Expedição",
        "image":"lojas.png",
        "image2":"lojas2.png",
        "content":"Somos especialistas e nosso atendimento é feito de forma presencial, por telefone e remotamente. Oferecemos soluções para compra e venda de moeda estrangeira, remessas internacionais e cartões pré-pagos para viagens internacionais. ",
      },
      {
        "title":"Finanças e Tesouraria",
        "image":"financas.png",
        "image2":"financas2.png",
        "content":"O time de finanças é dividido em três áreas: contabilidade, fiscal e controladoria, responsáveis por apoiar diretamente na administração, no crescimento e na consolidação dos negócios do Grupo.",
      },
      {
        "title":"Jurídico e Segurança Patrominial",
        "image":"juridico.png",
        "image2":"juridico2.png",
        "content":"Somos parceiros do negócio e garantimos que todas as empresas do Rendimento funcionem conforme a lei. Para isso, contamos com um time de profissionais que entendem das principais leis e regulamentações do mercado financeiro.",
      },
      {
        "title":"Operações e Cadastro",
        "image":"tesouraria.png",
        "image2":"tesouraria2.png",
        "content":"Nossa missão é apoiar o time comercial e a carteira de clientes em suas necessidades, garantindo que as tratativas eficientes para que os nossos produtos cheguem aos clientes de forma ágil e transparente. ",
      },
      {
        "title":"Auditoria",
        "image":"cadastro.png",
        "image2":"cadastro2.png",
        "content":"Nossa missão é identificar e mapear os processos e controles das áreas e os riscos inerentes envolvidos no negócio e manter uma estrutura de acordo com as exigências do Banco Central do Brasil.",
      },
      {
        "title":"Compliance, PLD, Riscos e SI",
        "image":"pld.png",
        "image2":"pld2.png",
        "content":"O time de Compliance e PLD é responsável por todas as validações necessárias para garantir a segurança dos nossos clientes e da instituição na realização das operações, mantendo a excelência dos nossos processos. ",
      },
      {
        "title":"Marketing e Produtos",
        "image":"marketing.png",
        "image2":"marketing2.png",
        "content":"Somos guardiões das marcas do Grupo, escutamos os clientes com atenção e pensamos em soluções inovadoras e sob medida para que eles tenham sempre a melhor experiência.",
      },
      {
        "title":"Planejamento Estratégico e PMO",
        "image":"planejamento.png",
        "image2":"planejamento2.png",
        "content":"Somos responsáveis por garantir uma visão clara da empresa, da sua identidade e dos objetivos organizacionais, além de promover o alinhamento entre todos os times, com foco em ajudar a antecipar os riscos na tomada de decisões.",
      },
      {
        "title":"Tecnologia da informação e B.I",
        "image":"ti.png",
        "image2":"ti2.png",
        "content":"Somos especializados em desenvolver a melhor experiência aos nossos clientes, seja por meio da arquitetura de tecnologia da informação, sustentação ou até mesmo uma governança de excelência.",
      },
      {
        "title":"Ouvidoria",
        "image":"ouvidoria.png",
        "image2":"ouvidoria2.png",
        "content":"A ouvidoria é responsável por ajudar e solucionar problemas que não foram atendidos inicialmente, mediando não apenas questões técnicas, mas tudo o que envolve o relacionamento com o cliente.",
      },
    ],

    collaboratorsArea: [
      {
        "image":"colaborador(8).jpeg",
        "content":`Em 2018, comecei o meu estágio na área de Benefícios e, em 2019, recebi a proposta de efetivação.<br>Me dediquei muito e sabia que estava no caminho certo, mas receber o reconhecimento foi especial.<br>Hoje, sou ponto focal de um dos principais processos de RH e, recentemente, recebi uma promoção. Agora, sou Analista Pleno.Tenho muito orgulho do meu crescimento profissional no Rendimento.`,
        "name":`<p><strong>Maria Araujo</strong></p>`,
        "func":`<p>Analista de RH</p>`,
      },
      {
        "image":"colaborador(7).jpeg",
        "content":`Na Cotação eu aprendi muito, tanto com os meus coordenadores que sempre me auxiliam, quanto com os meus colegas de trabalho, propiciando um ambiente que me ajudou muito a crescer como profissional. É uma empresa que me deu oportunidades de evoluir, é um ótimo lugar para trabalhar e adquirir conhecimento, um lugar que faz você melhorar cada dia mais.`,
        "name":`<p><strong>Arthur de Jesus Vilela</strong></p>`,
        "func":`<p>Operador SEFIC PF TR</p>`,

      },
      {
        "image":"colaborador(5).jpeg",
        "content":`Estou no Rendimento há 11 anos atuando nas áreas de Câmbio e Comercial.<br />
        Iniciei minha trajetória no Banco Rendimento e com o passar do tempo recebi uma proposta para atuar pela Cotação e recentemente obtive outra promoção, onde passei a trabalhar no Rendimento/pay.<br />
        Sou grata por todas as oportunidades e pela confiança.`,
        "name":`<p><strong>Andrea Carnevalli</strong><br></p>`,
        "func":`<p>Assessor Comercial</p>`,
      },
      {
        "image":"colaborador(4).jpeg",
        "content":`O que me motiva a trabalhar no Rendimento é o mesmo que motiva minha fidelidade a instituição há quase 25 anos.<br />
        Desde o início e sempre, a empresa se caracterizou por uma cultura ética, um espírito permanente de inovação e forte integração entre os seus colaboradores. Como parte integrante da equipe, me sinto feliz em participar de diferentes projetos, contribuir para o desenvolvimento dos colaboradores e de obter o reconhecimento final dos clientes pelo ótimo atendimento!`,
        "name":`<p><strong>Tania Borja Gasparian</strong><br></p>`,
        "func":`<p>Gerente de Qualidade</p>`,
      },
      {
        "image":"colaborador(3).jpeg",
        "content":`Após 2 anos como atendente fui aprovado no processo seletivo interno para Coordenador de Loja. Com a experiência adquirida, feedbacks e apoio dos meus líderes alcancei um dos meus objetivos. Hoje sou responsável pela gestão de 10 lojas do Rendimento. Com este histórico só tenho a confirmação que estou na empresa certa, e que todos meu esforço foi reconhecido durante toda a minha trajetória.<br />
        Sou grato em fazer parte deste time e estar dia a dia contribuindo para a evolução da empresa.`,
        "name":`<p><strong>Everton de Carvalho</strong><br></p>`,
        "func":`<p>Gerente de Loja</p>`,
      },
      {
        "image":"colaborador(2).jpeg",
        "content":"Trabalhar no Banco Rendimento é uma verdadeira paixão para mim. A oportunidade de ajudar os colaboradores em suas necessidades, é um grande desafio e uma motivação diária. Além disso, o ambiente de trabalho é extremamente agradável e a cultura da empresa é inigualável, proporcionando o meu aprimoramento e crescimento profissional.",
        "name":`<p><strong>Monike Gabrielle Palazini Pereira</strong><br></p>`,
        "func":`<p>Analista de infraestrutura ADM</p>`,
      },
      {
        "image":"colaborador(1).jpeg",
        "content":`Durante esses quase 10 anos de Rendimento aprendi que o maior valor do Grupo são as pessoas. Para além de um ambiente de trabalho saudável, temos aqui muito mais do que isso. Temos colaboração, apoio, incentivo e amizade, além da oportunidade de aprender com cada área e cada etapa do processo. São os desafios que nos movem, mas são as pessoas que nos impulsionam.`,
        "name":`<p><strong>Agnes Bianchi</strong><br></p>`,
        "func":`<p>Superintendente Comercial</p>`,
      },

      {
        "image":"colaborador-mariana-emilio.jpeg",
        "content":`O que me motiva aqui é saber que o canal de comunicação entre colaborador e diretoria está sempre aberto! Comecei como estagiária em 2021 e hoje vejo a possibilidade de uma carreira aqui dentro. Além disso, gosto muito do ambiente corporativo do Rendimento, em poder acompanhar e ver sair do papel tantas entregas importantes. Exemplo disso foi a criação e implementação da nova marca da empresa, anunciada na festa de fim de ano. Essas e tantas outras entregas de valor, tenho o prazer de ver nascer e tomar forma.`,
        "name":`<p><strong>Mariana Emilio da Costa</strong><br></p>`,
        "func":`<p>Analista de Projetos Jr</p>`,
      },
      {
        "image":"colaborador-jacques.jpeg",
        "content":`Eu fui o primeiro Estágiario do Rendimento em 2001 e durante a minha jornada atuei em diversas áreas, como: controladora, cadastro, BackOffice, renda fixa e comercial. <br />
        Não imaginava que cresceria rapidamente, contudo, sempre me esforcei para aprender coisas novas e dar o melhor de mim. Hoje sou superintendente de área comercial, tenho uma equipe incrível, que assim como eu, se desenvolveu muito. O Rendimento, é uma empresa que proporciona grandes desafios, mas que permite ter visibilidade, confiança, autonomia.`,
        "name":`<p><strong>Jacques Zylbergeld</strong><br></p>`,
        "func":`<p>Superintendente de Operações de Câmbio</p>`,
      },
      {
        "image":"colaborador-jonatas-de-novaes-amarim.jpeg",
        "content":`Trabalho no Rendimento há mais de 10 anos, e tem sido uma trajetória incrível, repleta de aprendizados e crescimento profissional. <br />
        Sou extremamente grato pela confiança depositada em mim pelos gestores e diretores da instituição. Essa confiança tem sido um incentivo constante para me superar e aplicar meu conhecimento na criação, elaboração e desenvolvimento de novas conciliações e controles, bem como na melhoria dos processos existentes.
        <br />
        Sinto-me honrado em fazer parte de uma equipe excepcional, onde a colaboração é valorizada e cada um contribui para o sucesso coletivo.<br />
        Agradeço por essa oportunidade e pela valorização do meu trabalho ao longo desses anos.`,
        "name":`<p><strong>Jonatas de Novaes Amarim</strong><br></p>`,
        "func":`<p>Analista Back office Contas Correntes</p>`,
      },
    ],

    benefitsName:[
      {
        "title":"Saúde e bem-estar",
      },
      {
        "title":"Financeiro",
      },
      {
        "title":"Cultura e Lazer",
      },
      {
        "title":"Desenvolvimento e Educação",
      },
    ],

    benefitsCards:[
      {
        "id":0,
        "image":"item(20).svg",
        "name":"Assistência médica",
      },
      {
        "id":0,
        "image":"item(19).svg",
        "name":"Assistência odontológica",
      },
      {
        "id":0,
        "image":"item(18).svg",
        "name":"Desconto em medicamentos",
      },
      {
        "id":0,
        "image":"item(17).svg",
        "name":"Seguro de vida",
      },
      {
        "id":1,
        "image":"item(16).svg",
        "name":"Vale Alimentação, Vale Refeição, Vale Combustível",
      },
      {
        "id":1,
        "image":"item(15).svg",
        "name":"Empréstimo consignado",
      },
      {
        "id":1,
        "image":"item(14).svg",
        "name":"Remuneração variável",
      },
      {
        "id":2,
        "image":"item(13).svg",
        "name":"Gympass",
      },
      {
        "id":2,
        "image":"item(12).svg",
        "name":"Clube Íris",
      },
      {
        "id":3,
        "image":"item(11).svg",
        "name":"Mov",
      },
      {
        "id":3,
        "image":"item(10).svg",
        "name":"Universidade Rendimento",
      },
    ],

    faq: {
      "slug": "faq",
      "title": "Faq",
      "faqItems": [
        {
          "title": "Onde está localizado a matriz e seus escritórios?",
          "content": `<p>A matriz do Rendimento está localizada em São Paulo, e seus escritórios estão em Campinas, Ribeirão Preto, Rio de Janeiro, Belo Horizonte, Porto Alegre e Curitiba.</p>`,
        },
        {
          "title": "Onde está localizada as lojas do Rendimento?",
          "content": `<p>Temos lojas em diversas regiões do Brasil, para mais informações, acesse: <a href="https://www.cotacao.com.br/nossas-lojas/">https://www.cotacao.com.br/nossas-lojas/</a></p>`,
        },
        {
          "title": "Existe alguma taxa sobre a inscrição?",
          "content": `<p>Não! A inscrição e processo seletivo são completamente gratuitos.</p>`,
        },
        {
          "title": "Não encontrei nenhuma vaga com o meu perfil, o que devo fazer?",
          "content": `<p>Contamos com um banco de currículo que é frequentemente visitado pelo nosso time de atratividade. Basta clicar em “Deixe seu currículo”.</p>`,
        },
        {
          "title": "Há vagas para pessoas com deficiência?",
          "content": `<p>Todas as nossas vagas são abertas para pessoas com deficiência, pois cultivamos um ambiente positivo para diversidade e inclusão.</p>`,
        },
        {
          "title": "Quais são as etapas do processo seletivo?",
          "content": `<p>Os nossos processos seletivos podem variar conforme a oportunidade, entretanto, consideramos sempre: Candidatura, avaliações, triagem de candidatos, dinâmica/ Análise de case (se houver a necessidade) e entrevistas com time de RH e gestor da área.</p>`,
        },
        {
          "title": "Me inscrevi em uma oportunidade, e agora?",
          "content": `<p>Caso seu currículo esteja de acordo  com a oportunidade nosso time de Atratividade entrará em contato, do contrario você receberá nosso e-mail de agradecimento.</p>`,
        },
        {
          "title": "Vou receber feedback sobre o processo seletivo?",
          "content": `<p>Sim! Você receberá nosso retorno em caso de feedback positivo ou negativo.</p>`,
        },
      ]
    }
  },


  getters: {
    basicProfileEmpty: state => {
      const profile = state.user.profile;

      return (
        !profile.nationality || profile.nationality.length == 0 ||
        (
          (!profile.cpf || profile.cpf.length == 0) &&
          (!profile.passport || profile.passport.length == 0)
        ) ||
        !profile.phone || profile.phone.length == 0 ||
        !profile.birthday || profile.birthday.length == 0 ||
        !profile.gender || profile.gender.length == 0 ||
        !profile.raceAndEthnicity || profile.raceAndEthnicity.length == 0 ||
        !profile.pronoun || profile.pronoun.length == 0 ||
        !profile.personalIncome || profile.personalIncome.length == 0 ||
        !profile.location.zipcode || profile.location.zipcode.length == 0 ||
        !profile.location.street || profile.location.street.length == 0 ||
        !profile.location.number || profile.location.number.length == 0 ||
        !profile.location.neighborhood || profile.location.neighborhood.length == 0 ||
        !profile.location.city || profile.location.city.length == 0 ||
        !profile.location.stateId || profile.location.stateId.toString().length == 0
      ) &&
        (!profile.educations || profile.educations.length == 0) &&
        (!profile.professionalExperiences || profile.professionalExperiences.length == 0 || state.flag_no_professional_experience == false)
    }
  },


  mutations: {
    CHANGE_TKN(state, payload){
      state.tkn = payload;
    },

    DEVISE_FORM(state, payload) {
      state.deviseForm = payload;
    },

    DEVISE_LOADING(state, payload) {
      state.deviseLoading = payload;
    },

    DEVISE_TRYING(state, payload) {
      state.deviseTrying = payload == null ? { } : payload;
    },

    DEVISE_DEVISE_CLOSED_TO_READ_TERMS(state, payload) {
      state.deviseClosedToReadTerms = payload == null ? { } : payload;
    },

    SET_PENDING_ACCEPT_TERMS(state, payload) {
      state.pendingAcceptTerms = payload;
    },

    PERSONAL_DATA_FORM(state, payload) {
      state.personalDataForm = payload;
    },

    EDUCATIONS_FORMS(state, payload) {
      if (!payload) {
        state.educationsForms = []
      } else {
        if (state.educationsForms.find(form => form._uid == payload._uid)) {
          state.educationsForms[state.educationsForms.findIndex(form => form._uid == payload._uid)] = payload;
        } else {
          state.educationsForms.push(payload);
        }
      }
    },

    PROFESSIONAL_EXPERIENCES_FORMS(state, payload) {
      if (!payload) {
        state.professionalExperiencesForms = []
      } else {
        if (state.professionalExperiencesForms.find(form => form._uid == payload._uid)) {
          state.professionalExperiencesForms[state.professionalExperiencesForms.findIndex(form => form._uid == payload._uid)] = payload;
        } else {
          state.professionalExperiencesForms.push(payload);
        }
      }
    },

    LANGUAGES_FORMS(state, payload) {
      if (!payload) {
        state.languagesForms = []
      } else {
        if (state.languagesForms.find(form => form._uid == payload._uid)) {
          state.languagesForms[state.languagesForms.findIndex(form => form._uid == payload._uid)] = payload;
        } else {
          state.languagesForms.push(payload);
        }
      }
    },

    SET_FLAG_PROFESSIONAL_EXPERIENCE(state, payload) {
      state.flag_no_professional_experience = payload
    },

    OPPORTUNITY_QUESTIONS_FORM(state, payload) {
      state.opportunityQuestionsForm = payload
      localStorage.setItem('opportunity_questions', JSON.stringify(payload))
    },

    INDICATION_FORM(state, payload) {
      state.indicationForm = payload
      localStorage.setItem('indication_form', JSON.stringify(payload))
    }
  },

  actions: {
  }
})
